import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, type ButtonProps } from '@fs/zion-ui'
import { ContentAdd } from '@fs/zion-icon'

type Props =
  | Omit<Exclude<ButtonProps, { to: unknown }>, 'children'>
  | Omit<Extract<ButtonProps, { to: unknown }>, 'children'>

export default function AddNoteButton(buttonProps: Props): JSX.Element {
  const [t] = useTranslation()
  return (
    <Button Icon={ContentAdd} data-testid="add-note-button" {...buttonProps}>
      {t('tree-person.add-note.action')}
    </Button>
  )
}
